<template>
    <!-- Main Container -->
    <main id="main-container">
        <!-- Hero -->
        <Hero :title="title" :page="page" />
        <!-- END Hero -->
        <!-- Page Content -->
        <div class="content">
            <!-- Panel -->
            <div class="row">
                <div class="col-md-6 col-xl-6">
                    <div class="block block-rounded block-link-shadow bg-primary">
                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                            <div>
                                <i class="fa fa-2x fa-barcode text-primary-lighter"></i>
                            </div>
                            <div class="ms-3 text-end">
                                <p class="text-white fs-3 fw-medium mb-0">
                                    Dispositivo
                                </p>
                                <p class="text-white-75 mb-0">
                                    {{index_datos.sn || "ESP32"}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
             
                <div class="col-md-6 col-xl-6">
                    <div class="block block-rounded block-link-shadow bg-warning">
                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                            <div class="me-3">
                                <p class="text-white fs-3 fw-medium mb-0">
                                    WiFi RSSI
                                </p>
                                <p class="text-white-75 mb-0">
                                    {{index_datos.wrssi}} dBm
                                </p>
                            </div>
                            <div>
                                <i class="fa fa-2x fa-signal text-success-light"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="block block-rounded block-link-shadow">
                        <div class="block-content block-content-full">
                            <div class="row text-center">
                                <div class="col-6 border-end">
                                    <div class="py-3">
                                        <div class="item item-circle bg-body-light mx-auto">
                                            <i class="fa fa-memory text-primary"></i>
                                        </div>
                                        <p class="fs-3 fw-medium mt-3 mb-0">
                                            {{ram_percent_free.toFixed(2)}} %
                                        </p>
                                        <p class="text-muted mb-0">
                                            RAM Disponible
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 border-end">
                                    <div class="py-3">
                                        <div class="item item-circle bg-body-light mx-auto">
                                            <i class="fa fa-satellite-dish text-primary"></i>
                                        </div>
                                        <p class="fs-3 fw-medium mt-3 mb-0">
                                            {{index_datos.ws || 0}} %
                                        </p>
                                        <p class="text-muted mb-0">
                                            Señal WIFi
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="block block-rounded bg-gd-sublime">
                        <div class="block-content block-content-full">
                            <div class="row text-center">
                                <div class="col-4 border-end border-black-op">
                                    <div class="py-3">
                                        <div class="item item-circle bg-black-25 mx-auto">
                                            <i class="fa fa-hdd text-white"></i>
                                        </div>
                                        <p class="text-white fs-3 fw-medium mt-3 mb-0">
                                            {{spiffs_percent_used.toFixed(2)}} %
                                        </p>
                                        <p class="text-white-75 mb-0">
                                            SPIFFS Usada
                                        </p>
                                    </div>
                                </div>
                                <div class="col-4 border-end border-black-op">
                                    <div class="py-3">
                                        <div class="item item-circle bg-black-25 mx-auto">
                                            <i class="fa fa-sync text-white"></i>
                                        </div>
                                        <p class="text-white fs-3 fw-medium mt-3 mb-0">
                                            {{index_datos.rbn || 0}}
                                        </p>
                                        <p class="text-white-75 mb-0">
                                            Reinicios
                                        </p>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="py-3">
                                        <div class="item item-circle bg-black-25 mx-auto">
                                            <i class="fa fa-clock text-white"></i>
                                        </div>
                                        <p class="text-white fs-4 fw-medium mt-3 mb-0">
                                            {{index_datos.at || "0:00:00:00"}}
                                        </p>
                                        <p class="text-white-75 mb-0">
                                            Tiempo Activo
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END Panel -->
            <!-- ROW Hardware & Software -->
            <div class="row mb-4">
                <!-- Hardware & Software -->
                <div class="col-md-6">
                    <div class="block block-rounded block-link-shadow h-100 mb-0">
                        <div class="block-content p-0 progress" style="height: 2px;">
                            <div class="progress-bar bg-info" role="progressbar" style="width: 100%;" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="block-content block-content-full">
                            <div>
                                <p class="fs-lg fw-semibold mb-2">
                                    Hardware & Software
                                </p>
                                <div class="table-responsive">
                                    <table class="table table-striped table-borderless table-vcenter mb-0">
                                        <tr>
                                            <td class="col-4">Número de Serie:</td>
                                            <td class="col-8">
                                                {{index_datos.sn || "ESP3200000000000" }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-4">Versión del Firmware:</td>
                                            <td class="col-8">
                                                {{index_datos.vf || "v0.0.00-Build-00000000"}}
                                            </td>
                                        </tr>
                                        
                                        <tr>
                                            <td class="col-4">Versión del Hardware:</td>
                                            <td class="col-8">
                                                 {{index_datos.vh || "ADMINVUE32 v0 00000000"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-4">FLASH SIZE:</td>
                                            <td class="col-8">
                                                {{index_datos.fsz || 4.0}} MB
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-4">SPIFFS SIZE:</td>
                                            <td class="col-8">
                                                {{index_datos.spiffst/1000 || 15.31}} KB
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-4">SPIFFS USED:</td>
                                            <td class="col-8">
                                                {{index_datos.spiffsu/1000 || 0}} KB
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-4">Fabricante:</td>
                                            <td class="col-8">
                                                 {{index_datos.fb || "Savecontrol"}}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END Hardware & Software -->
                 <!-- Inalámbrico -->
                <div class="col-md-6">
                    <div class="block block-rounded block-link-shadow h-100 mb-0">
                        <div class="block-content p-0 progress" style="height: 2px;">
                            <div role="progressbar" style="width: 100%;" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="block-content block-content-full">
                            <div>
                                <p class="fs-lg fw-semibold mb-2">
                                    Inalámbrico
                                </p>
                                <div class="table-responsive">
                                    <table class="table table-striped table-borderless table-vcenter mb-0">
                                        <tr>
                                            <td class="col-3">Estado WiFi:</td>
                                            <td class="col-6" style="margin-left: 20px;">
                                                <span class="badge bg-success">CONECTADO</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-3">SSID WiFi:</td>
                                            <td class="col-6">
                                                {{index_datos.wssid || "cannot connect to WiFi"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-3">IP WiFi:</td>
                                            <td class="col-6">
                                                {{index_datos.ip || "000.000.000.000"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-3">MAC WiFi:</td>
                                            <td class="col-6">
                                                {{index_datos.mac || "00:00:00:00:00:00"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="col-3">RSSI WiFi:</td>
                                            <td class="col-6">
                                                {{index_datos.wrssi || 0}} dBm
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END Inalámbirco -->
            </div>
            <!-- END ROW Hardware & Software -->
        </div>
        <!-- END Page Content -->
    </main>
    <!-- END Main Container -->
</template>

<script>
import useIndex from '@/composables/useIndex'
export default {
        components: {  },
        name: 'device-info',
        setup() {
            const title = "Información del Dispositivo"
            const page = "dispositivo-info"

            const {
            index_datos,          
            spiffs_percent_used,
            ram_percent_free,            
            } = useIndex()

        return{
            title,
            page,
            index_datos,           
            spiffs_percent_used,
            ram_percent_free,
    
        }
    }
}
</script>
